module.exports = __webpack_public_path__ + "static/media/modern1.7f9883a7.jpg";